'use strict';

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _ticketService = require('./ticket.service');

var _ticketService2 = _interopRequireDefault(_ticketService);

angular.module('BTMS').service('TicketComponent', _ticketService2['default']);


/** WEBPACK FOOTER **
 ** ./client/components/ticket/index.js
 **/